module.exports = global["jQuery"] = require("-!/start/assets/node_modules/expose-loader/index.js?$!/start/assets/node_modules/jquery/dist/jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/dist/jquery.js
 ** module id = 9
 ** module chunks = 12 13 15 16 18 19 20 21 22 23 24 25 26 28 29 30 31 32 33 34 36 37
 **/